import ShipmentIcon from '@material-ui/icons/LocalShipping';
import ShipmentList from './ShipmentList';
import ShipmentEdit from './ShipmentEdit';


export default {
    list: ShipmentList,
    edit: ShipmentEdit,
    //create: DonorCreate,
    icon: ShipmentIcon,
};
